import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar';

function RegistroExitoso() {
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    // Trackear conversión de registro
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-970875118/registro_conversion',
        value: 1.0,
        currency: 'EUR'
      });
      
      // Google tag event
      window.gtag('event', 'conversion_event_signup_1', {
        // <event_parameters>
      });
    }

    // Countdown y redirección automática
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div style={{ padding: 20 }}>
      <Navbar />
      <div style={{ 
        textAlign: 'center', 
        maxWidth: '600px', 
        margin: '50px auto',
        padding: '30px',
        backgroundColor: '#f8f9fa',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ color: '#28a745', marginBottom: '20px' }}>
          🎉 ¡Registro completado!
        </h1>
        <p style={{ fontSize: '1.1em', marginBottom: '20px' }}>
          Te has registrado correctamente. Ya puedes empezar a añadir productos y recibir alertas de precios.
        </p>
        <p style={{ fontSize: '0.9em', color: '#666', marginBottom: '20px' }}>
          Redirigiendo en {countdown} segundos...
        </p>
        <a 
          href="/" 
          style={{
            display: 'inline-block',
            padding: '12px 24px',
            backgroundColor: '#007bff',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '5px',
            fontWeight: 'bold'
          }}
        >
          Añadir mi primer producto
        </a>
      </div>
    </div>
  );
}

export default RegistroExitoso;